export enum OrderShipmentStatus {
    NotApplicable = -1,
    Pending = 0,
    Open = 1,
    Assigned = 2,
    InTransit = 3,
    Completed = 4
}

export const OrderShipmentStatusMetadata = {
    '-1': {
        display: 'Not Applicable',
        class: 'na',
        value: -1
    },
    '0': {
        display: 'Pending',
        class: 'waiting',
        value: 0
    },
    '1': {
        display: 'Open',
        class: 'waiting',
        value: 1
    },
    '2': {
        display: 'Assigned',
        class: 'inprogress',
        value: 2
    },
    '3': {
        display: 'In-Transit',
        class: 'inprogress',
        value: 3
    },
    '4': {
        display: 'Completed',
        class: 'done',
        value: 4
    }
};
